function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_22",
  "data-name": "Trac\\xE9 22",
  d: "M26.711.091a.792.792,0,0,0-.787.044L22.24,2.551,18.418.128a.788.788,0,0,0-.841,0L13.794,2.551,10.019.128a.788.788,0,0,0-.841,0L5.357,2.551,1.665.128A.791.791,0,0,0,.878.083a.722.722,0,0,0-.4.648V32.042a.753.753,0,0,0,.764.737H26.352a.753.753,0,0,0,.764-.737V.732a.719.719,0,0,0-.405-.641ZM25.588,31.313H2V2.131l2.92,1.915a.786.786,0,0,0,.848.007L9.591,1.623l3.783,2.424a.8.8,0,0,0,.848,0L18,1.623l3.821,2.431a.786.786,0,0,0,.848-.007l2.92-1.915Zm0,0",
  transform: "translate(-0.473 0.001)",
  fill: "#676767"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_23",
  "data-name": "Trac\\xE9 23",
  d: "M95.773,354.543h-11.3a.851.851,0,0,0,0,1.674h11.3a.851.851,0,0,0,0-1.674Zm0,0",
  transform: "translate(-76.799 -328.59)",
  fill: "#676767"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_24",
  "data-name": "Trac\\xE9 24",
  d: "M119.006,147.395a.835.835,0,0,0,.6-1.557,5.634,5.634,0,0,0-6,1.272,5.566,5.566,0,0,0-1.339,2.151h-.862a.837.837,0,1,0,0,1.674h.561c0,.151,0,.31.008.46h-.569a.837.837,0,0,0,0,1.674h.921a5.718,5.718,0,0,0,1.281,1.992,5.622,5.622,0,0,0,6,1.272.835.835,0,0,0-.6-1.556,3.961,3.961,0,0,1-4.218-.9,4.038,4.038,0,0,1-.62-.8h3.8a.837.837,0,0,0,0-1.674H113.65c-.008-.1-.017-.209-.017-.31v-.151h4.82a.837.837,0,1,0,0-1.674h-4.385a4.209,4.209,0,0,1,.711-.971,3.949,3.949,0,0,1,4.226-.9Zm0,0",
  transform: "translate(-102.546 -135.377)",
  fill: "#676767"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "Trac\\xE9_25",
  "data-name": "Trac\\xE9 25",
  d: "M66.3,95.543c-4.709,0-8.526,4.384-8.526,9.792s3.817,9.792,8.526,9.792,8.526-4.384,8.526-9.792S71,95.55,66.3,95.543Zm0,17.91c-3.9,0-7.069-3.635-7.069-8.118s3.165-8.118,7.069-8.118,7.069,3.634,7.069,8.118S70.2,113.449,66.3,113.453Zm0,0",
  transform: "translate(-52.975 -89.566)",
  fill: "#676767"
});

var SvgIcBill = function SvgIcBill(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "invoice_1_",
    "data-name": "invoice (1)",
    width: 26.643,
    height: 32.78,
    viewBox: "0 0 26.643 32.78",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcBill, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ic_bill.5728e376.svg";
export { ForwardRef as ReactComponent };